import { ReactNode } from 'react';
import { BordOneToneIcon, NudosButton } from 'components/NudosComponents';
import { InudosButton } from 'components/NudosComponents/NudosButton/NudosButton';
import './BordFloatIsland.scss';

interface IBordFloatIsland {
  customClassName?: string;
  leftContentText?: string;
  leftContentCount?: number;
  buttonProps?: InudosButton;
  buttonText?: string;
  buttonIcon?: string | JSX.Element;
  isButtonDisabled?: boolean;
  modal?: ReactNode;
  isModalOpen?: boolean;
  onClose?: () => void;
  onButtonClick?: () => void;
}

const BordFloatIsland = ({
  customClassName = '',
  leftContentText = 'Productos seleccionados',
  leftContentCount,
  buttonProps,
  buttonText = 'Descargar todos los QR',
  buttonIcon = <BordOneToneIcon variant="download" customWidth="10px" stroke="#FFFFFF" />,
  isButtonDisabled,
  modal,
  isModalOpen,
  onClose,
  onButtonClick
}: IBordFloatIsland) => {
  const handleButtonClick = () => {
    if (!isButtonDisabled) {
      onButtonClick?.();
    }
  };

  return (
    <>
      <div className={`bordFloatIsland ${customClassName}`}>
        <div className="floatIslandLeftContent">
          {leftContentCount && onClose && (
            <div className="cursor-pointer" onClick={onClose}>
              <BordOneToneIcon variant="x" customWidth="16px" stroke="#FFFFFF" />
            </div>
          )}
          <span className="floatIslandLeftContentText">
            {`${leftContentText} ${leftContentCount ? `(${leftContentCount})` : ''}`}
          </span>
        </div>
        <div className="floatIslandDivider" />
        <div className="floatIslandRightContent floatIslandCustomButton" onClick={handleButtonClick}>
          <NudosButton
            buttonText={buttonProps?.buttonText ?? buttonText}
            buttonIcon={buttonProps?.buttonIcon ? buttonProps.buttonIcon : buttonIcon}
            isButtonDisabled={isButtonDisabled}
            {...(buttonProps ?? {})}
          />
        </div>
      </div>

      {isModalOpen && modal}
    </>
  );
};

export default BordFloatIsland;
